import { InputAdornment } from '@material-ui/core'
import { AttachMoney } from '@material-ui/icons'
import { MONEDA } from 'Constants'
import moment from 'moment'

export const PaymentOrderFields = (data, handleChange, edit, permissions) => {
  return [
    {
      label: 'ID orden',
      class: 'textfield',
      value: data.id,
      sm: 1,
      xs: 12,
      disabled: true,
    },
    {
      label: 'Nº comprobante',
      class: 'textfield',
      value: data.comprobante,
      sm: 2,
      xs: 12,
      disabled: true,
    },
    {
      label: 'Fecha creación',
      class: 'textfield',
      value: data.fecha ? moment(data.fecha).format('DD/MM/YYYY') : '',
      sm: 2,
      xs: 12,
      disabled: true,
    },
    {
      label: 'Usuario',
      class: 'textfield',
      value: data.usuario,
      sm: 3,
      xs: 12,
      disabled: true,
    },
    {
      label: 'Observación',
      class: 'textfield',
      name: 'observacion',
      value: data.observacion,
      sm: 4,
      xs: 12,
      disabled: !data.comprobante || permissions.allowEditMin ? true : !edit,
      onChange: (e) => {
        handleChange('observacion', e.target.value)
      },
    },
  ]
}

export const DataExtra = (data) => {
  const formatSaldo = (value) => {
    return parseFloat(value).toString()
  }
  return [
    {
      label: 'Saldo restante',
      class: 'textfield',
      value: data?.saldoResto ? formatSaldo(data.saldoResto.toFixed(1)) : 0,
      sm: 8,
      xs: 12,
      disabled: true,
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
    },
    {
      label: 'Total orden de pago',
      class: 'textfield',
      value: data?.total ? formatSaldo(Number(data.total)) : 0,
      sm: 8,
      xs: 12,
      disabled: true,
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
    },
  ]
}

export const fieldsAddPaymentOrder = (values, handleChange, isLoading, data) => {
  const tarjetasFiltradas =
    values.tipo === 2
      ? data.tarjetas.filter((tarjeta) => tarjeta.tipo === 1)
      : values.tipo === 3
        ? data.tarjetas.filter((tarjeta) => tarjeta.tipo === 2)
        : []

  const handlePaymentMethodChange = (e) => {
    handleChange('tipo', e.id)
    handleChange('origen', null)
    handleChange('importe', '')
    handleChange('descripcion', '')
    handleChange('proveedor', null)
    handleChange('nro_operacion', '')
    handleChange('moneda', null)
    handleChange('cotizacion', '')
    handleChange('lote', '')
    handleChange('cupon', '')
  }

  const IMPORTE = {
    label: 'Importe',
    name: 'importe',
    sm: [5, 60, 70, 51].includes(values.tipo) ? 12 : 6,
    xs: 12,
    class: 'textfield',
    type: 'number',
    inputProps: {
      startAdornment: (
        <InputAdornment position="start">
          <AttachMoney />
        </InputAdornment>
      ),
    },
    value: Math.max(0, parseFloat(values.importe)),
    onChange: (e) => handleChange('importe', e.target.value),
  }
  const OBSERVACION = {
    label: 'Observación',
    name: 'detalle',
    sm: [1, 6, 7, 8, 51].includes(values.tipo) ? 6 : 12,
    xs: 12,
    class: 'textfield',
    value: values.detalle,
    onChange: (e) => handleChange('detalle', e.target.value),
  }
  return [
    {
      label: 'Método de pago',
      name: 'tipo',
      options: data.metodosPago.filter(
        (metodo) => metodo.id !== 5 && metodo.id !== 10 && metodo.id !== 9
      ),
      optionLabel: `options["tipo"]`,
      optionValue: 'id',
      value: values.tipo,
      sm: 12,
      xs: 12,
      class: 'autocomplete',
      onChange: handlePaymentMethodChange,
    },
    ...(values.tipo === 1
      ? [IMPORTE, OBSERVACION]
      : values.tipo === 4
        ? [
            IMPORTE,
            {
              label: 'Nº de operación',
              name: 'nro_operacion',
              sm: 6,
              class: 'textfield',
              type: 'number',
              disabled: ![4, 6, 7].includes(values.tipo),
              value: Math.max(0, parseInt(values.nro_operacion)),
              onChange: (e) => handleChange('nro_operacion', e.target.value),
            },
            OBSERVACION,
          ]
        : values.tipo === 2 || values.tipo === 3
          ? [
              {
                label: 'Tarjeta',
                name: `origen_${values.tipo}`,
                sm: 6,
                xs: 12,
                class: 'autocomplete',
                disabled: values.tipo === 2 || values.tipo === 3 ? false : true,
                value: values.origen,
                options: tarjetasFiltradas,
                optionLabel: `options["nombre"]`,
                optionValue: 'id',
                onChange: (e) => {
                  handleChange('origen', e.id)
                },
              },
              IMPORTE,
              {
                label: 'Lote',
                name: 'lote',
                sm: 6,
                xs: 12,
                class: 'textfield',
                type: 'number',
                disabled: values.tipo === 2 || values.tipo === 3 ? false : true,
                value: Math.max(0, parseInt(values.lote)),
                onChange: (e) => handleChange('lote', e.target.value),
              },
              {
                label: 'Cupón',
                name: 'cupon',
                sm: 6,
                xs: 12,
                class: 'textfield',
                type: 'number',
                disabled: values.tipo === 2 || values.tipo === 3 ? false : true,
                value: Math.max(0, parseInt(values.cupon)),
                onChange: (e) => handleChange('cupon', e.target.value),
              },
              OBSERVACION,
            ]
          : values.tipo === 10
            ? [
                {
                  label: 'Nº cheque',
                  name: 'cheque',
                  sm: 6,
                  xs: 12,
                  class: 'textfield',
                  type: 'number',
                  disabled: values.tipo === 5 || values.tipo === 10 ? false : true,
                  value: Math.max(0, parseInt(values.cheque)),
                  onChange: (e) => handleChange('cheque', e.target.value),
                },
                IMPORTE,
                {
                  label: 'Banco',
                  name: `origen_${values.tipo}`,
                  sm: 6,
                  xs: 12,
                  class: 'autocomplete',
                  value: values.proveedor,
                  options:
                    values.tipo === 6 || values.tipo === 7
                      ? data.bancos.filter((banco) => banco.propio === 1)
                      : data.bancos.filter((banco) => banco.propio === 0),
                  optionLabel: `options["nombre"]`,
                  optionValue: 'id',
                  disabled: ![10, 6, 7].includes(values.tipo),
                  onChange: (e) => {
                    handleChange('origen', e.id)
                  },
                },
                {
                  label: 'Echeq / ID cheque',
                  name: 'barcode',
                  sm: 6,
                  xs: 12,
                  class: 'textfield',
                  disabled: values.tipo !== 10,
                  value: values.barcode,
                  onChange: (e) => handleChange('barcode', e.target.value),
                },
                OBSERVACION,
              ]
            : values.tipo === 6 || values.tipo === 7
              ? [
                  IMPORTE,
                  {
                    label: 'Banco',
                    name: `origen_${values.tipo}`,
                    sm: 6,
                    xs: 12,
                    class: 'autocomplete',
                    value: values.proveedor,
                    options:
                      values.tipo === 6 || values.tipo === 7
                        ? data.bancos.filter((banco) => banco.propio === 1)
                        : data.bancos.filter((banco) => banco.propio === 0),
                    optionLabel: `options["nombre"]`,
                    optionValue: 'id',
                    disabled: ![10, 6, 7].includes(values.tipo),
                    onChange: (e) => {
                      handleChange('origen', e.id)
                    },
                  },
                  {
                    label: 'Nº de operación',
                    name: 'nro_operacion',
                    sm: 6,
                    class: 'textfield',
                    type: 'number',
                    disabled: ![4, 6, 7].includes(values.tipo),
                    value: Math.max(0, parseInt(values.nro_operacion)),
                    onChange: (e) => handleChange('nro_operacion', e.target.value),
                  },
                  OBSERVACION,
                ]
              : values.tipo === 8
                ? [
                    IMPORTE,
                    {
                      label: 'Moneda',
                      name: `moneda_${values.tipo}`,
                      sm: 6,
                      xs: 12,
                      options: MONEDA,
                      value: values.moneda,
                      optionLabel: `options["label"]`,
                      optionValue: 'id',
                      class: 'autocomplete',
                      disabled: values.tipo !== 8,
                      onChange: (e) => {
                        handleChange('moneda', e.label)
                      },
                    },
                    {
                      label: 'Cotización',
                      name: 'cotizacion',
                      sm: 6,
                      xs: 12,
                      class: 'textfield',
                      type: 'number',
                      value: Math.max(0, parseInt(values.cotizacion)),
                      disabled: values.tipo !== 8,
                      onChange: (e) => handleChange('cotizacion', e.target.value),
                    },
                    OBSERVACION,
                  ]
                : values.tipo === 60
                  ? [IMPORTE, OBSERVACION]
                  : values.tipo === 70
                    ? [IMPORTE, OBSERVACION]
                    : values.tipo === 51
                      ? [
                          {
                            label: 'Retención',
                            name: `origen_${values.tipo}`,
                            sm: 12,
                            xs: 12,
                            class: 'autocomplete',
                            disabled:
                              values.tipo === 2 || values.tipo === 3 || values.tipo === 51
                                ? false
                                : true,
                            value: values.origen,
                            options: data.retenciones,
                            optionLabel: `options["nombre"]`,
                            optionValue: 'id',
                            onChange: (e) => {
                              handleChange('origen', e.id)
                            },
                          },
                          IMPORTE,
                        ]
                      : []),
  ]
}
